import React from "react";
import {
  LandingPageContainer,
  MainContainer,
  Title,
  DashedLineSeparator,
  Subtitle,
  Illustration,
  LandingPageImageContainer,
  Description,
  TimePill,
  TimeTitle,
  TitleContainer,
  MiddleTitleContainer,
} from "./Landing.style";
import { StandardButton } from "../../components";
import { RouteComponentProps } from "react-router";
import Store from "../../state/store";
import { inject, observer } from "mobx-react";
import Actions from "../../state/actions";
import { Link } from "react-router-dom";
import Icon from "../../icons";

interface Props extends RouteComponentProps {
  store?: Store;
  mutator?: Actions;
}

const LandingPage: React.FC<Props> = (props) => {
  const { content } = props.store!;

  return (
    <MainContainer background={content.branding.background}>
      <LandingPageContainer>
        <TitleContainer>
          <div style={{ width: "15%" }} />
          <MiddleTitleContainer>
            <Title>{content.branding.title}</Title>
            {content.branding.subtitle && (
              <React.Fragment>
                <DashedLineSeparator />
                <Subtitle>{content.branding.subtitle}</Subtitle>
              </React.Fragment>
            )}
          </MiddleTitleContainer>
          <div style={{ width: "15%" }}>
            <TimePill>
              <Icon name="timer" fill="white" width="2em" height="2em" />
              <div style={{ display: "flex", flexDirection: "column" }}>
                <TimeTitle>{content.totalTime.split(" ")[0]}</TimeTitle>
                <span style={{ fontWeight: "bold" }}>{content.totalTime.split(" ")[1]}</span>
              </div>
            </TimePill>
          </div>
        </TitleContainer>

        <Description>{content.intro}</Description>
        <Link to="/home">
          <StandardButton textButton={"Commencer le module"} />
        </Link>
      </LandingPageContainer>
      {content.branding.mainIllustration && (
        <LandingPageImageContainer>
          <Illustration image={content.branding.mainIllustration} />
        </LandingPageImageContainer>
      )}
    </MainContainer>
  );
};

export default inject("store", "mutator")(observer(LandingPage));
